import { schema } from 'normalizr';

export const materialClassSchema = new schema.Entity('materialClasses');
export const materialFamilySchema = new schema.Entity('materialFamilies');
export const materialSchema = new schema.Entity('materials');
export const opDefSchema = new schema.Entity('operationDefinitions');
export const customInterrogationSchema = new schema.Entity(
  'customInterrogations',
  {
    materialClasses: [materialClassSchema],
    materialFamilies: [materialFamilySchema],
    materials: [materialSchema],
    operationDefinitions: [opDefSchema],
  },
);
